import {t} from "@lingui/core/macro";
import React, {Fragment, useEffect, useState} from "react";
import {PlaySquareOutlined,UploadOutlined} from "@ant-design/icons"
import {Alert, Button, Divider, Form, Input, Switch, Upload} from "antd";

export default {
        Renderer: (props) => {
            const data=props.data

            const [loaded,setLoaded]=useState(false)
            useEffect(()=>{
                setLoaded(true)
            },[])

            if(!loaded){
                return null
            }

            return(
                <div style={{width:"100%",height:"inherit"}}>
                    {data.video && (
                        <video muted={data.autoPlay} autoPlay={data.autoPlay} controls src={data.video} style={{width:"100%",height:"inherit",backgroundColor:"#000"}} />
                    )}

                    {!data.video && (
                        <Alert showIcon type={"warning"} message={t`Veuillez télécharger une vidéo.`}/>
                    )}
                </div>
            )

        },
        id: 'video-viewer',
        title: 'Video',
        description: "Intégrez votre video mp4",
        icon: <PlaySquareOutlined />,
        version: 1,

}




